<ym-modal (onClose)="closeModal()">
    <ng-container header>
        <div class="ym-display-flex ym-gap-3 ym-justify-content-center ym-align-items-center">
            <span class="icon ym-svg-md">
                <ym-icon [iconName]="$any(currentActivityDefinition?.icon)"></ym-icon>
            </span>
            {{isLog? 'Log':'Add'}} {{currentActivityDefinition?.label??'' |
            textCase:textCases.LOWER_CASE}}
        </div>
    </ng-container>
    <ng-container body>
        <div class="main-content ym-display-flex ym-flex-direction-column ym-h-full ym-gap-6">
            <ng-container *ngIf="uiFields && uiFields.length">
                <ng-container *ngFor="let field of uiFields">
                    <ng-container *ngTemplateOutlet="fieldInput; context:{field: field}"></ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ng-container actions>
        <ym-button [type]="buttonTypes.PRIMARY" (onClick)="saveActivity()" [loading]="isLoading">
            Save
        </ym-button>
    </ng-container>
</ym-modal>


<ng-template #fieldInput let-field="field">
    <app-global-input [field_type]="field.field_type" [allUsers]="allUsers" [options]="field.option"
        [label]="field.label" [name]="field.name" [required]="field.required"
        [is_readonly_value]="field.is_readonly_value" [isInvalid]="field.isInvalid" [errorText]="field.errorText"
        (inputValueChange)="inputValueChange($event, field)" (invalidateField)="invalidateField($event,field)"
        [is_single_input_field]="true" *ngIf="!field.is_readonly_value"></app-global-input>
</ng-template>